import React, {createContext, useContext, useEffect, useState} from "react";
import {AuthContext} from "./auth.context";
import {ExchangeService} from "../service/exchange.service";
import {notification} from "antd";
import {TraderService} from "../service/trader.service";

export const exchangeLogos = {
    'coinbasepro': 'https://cdn.worldvectorlogo.com/logos/coinbase-primepro.svg',
    'binanceus': 'https://cdn.worldvectorlogo.com/logos/binance-logo.svg',
    'kraken': 'https://cdn.worldvectorlogo.com/logos/kraken-2.svg',
    'gemini': 'https://cdn.worldvectorlogo.com/logos/gemini-4.svg'
}

let traderSVC = new TraderService()
const ExchangeContext = createContext({
    exchanges: [],
    exchangesLoading: false,
    userStatus: false,
    selectedExchangeID: null,
    selectedImage: undefined,
    binanceLogo: exchangeLogos.binanceus,
    krakenLogo: exchangeLogos.kraken,
    coinbaseproLogo: exchangeLogos.coinbasepro,
    geminiLogo: exchangeLogos.gemini,
    onSelectExchange: (e)=>{},
    refreshExchanges: ()=>{},
    deleteExchange: (id)=>{},
    createExchange: (formData) =>{},
    toggleExchangeStatus: (exchange) =>{},
    logos: {},
})

const keyPrefix = "v3"
const exchangeKey = `${keyPrefix}selectedExchange`
const getStoredExchange= ()=> localStorage.getItem(exchangeKey)
const clearStoredExchange= ()=> localStorage.removeItem(exchangeKey)
const setStoredExchange = (val) => localStorage.setItem(exchangeKey, val)

let svc = new ExchangeService()
let globalStatus = false
function setGlobalStatus(status){
    globalStatus = status
}

const ExchangeProvider = (props)=>{
    const authContext = useContext(AuthContext)
    const [exchangesLoading, setExchangesLoading] = useState(true)
    const [exchanges, setExchanges] = useState([])
    const [selectedExchange, setSelectedExchange] = useState("")
    const [selectedImage, setSelectedImage] = useState('')
    const [preSelected, setPreSelected] = useState(false)
    const [logos, setLogos] = useState({})
    const [userStatus, setUserStatus] = useState(globalStatus)
    let firstTime = true

    useEffect(()=>{
        let id = setInterval(()=>{
            setUserStatus(globalStatus)
        }, 1000)

        return ()=>{
            clearInterval(id)
        }
    })

    useEffect(()=>{
        clear().then((r)=>{
            if(authContext.token && firstTime){
                firstTime = false
                preSelect(r)
            }

            if(!authContext.token){
                firstTime = true
            }
        })

    }, [authContext.token])

    useEffect(()=>{
        if(preSelected && exchanges.length){
            setPreSelected(false)
            preSelect(exchanges, false)
        }
    }, [exchanges, preSelected])

    const createExchange = async (data) =>{
        try{
            await svc.create(data)
        }catch (e){
            if(e.status == 422){
                notification.error({
                    message: "Profile Exists",
                    description: "You already have a profile with those credentials",
                })
                return false
            }
            notification.error({
                message: "An error occurred",
                description: e.rawErrorMessage,
            })
            return false
        }

        try{
            await onRefreshExchange()
        } catch (e){
            notification.error({
                message: "An error occurred",
                description: "Something went wrong",
            })
            return false
        }


        return true
    }

    const clear = async ()=>{
        if(authContext.token){
            setExchangesLoading(true)
            return svc.list().then((results)=>{
                setExchanges(results);
                setSelectedExchange(null)
                let l = {};
                results.forEach((r)=>{
                    l[r.id] = exchangeLogos[r.type]
                })
                setLogos(l)
                return results
            }).catch((e)=>{
                console.error("error loading exchange list")
                console.error(e)
            }).finally(()=>{
                setExchangesLoading(false)
            })
        } else {
            setExchanges([])
            setSelectedExchange(null)
        }
    }

    const preSelect = (exchanges, noSet)=>{
        let id = getStoredExchange()

        if(!id){return }
        let found = exchanges?.filter?.((e)=>{
            let r = e.id == id;
            if(r){
                if(!noSet){
                    setPreSelected(true)
                }

                onSelectExchange(e.id).then()
            }

            return r
        }).length

        if(!found){
            clearStoredExchange()
        }
    }

    const onSelectExchange = async (exchangeID)=>{
        if(!exchangeID){return}
        setSelectedExchange(exchangeID)
        setStoredExchange(exchangeID)
        exchanges.forEach((e)=>{
            if(e.id == exchangeID){
                let logo = exchangeLogos[e.type]
                if(logo){
                    setSelectedImage(logo)
                }
            }
        })
    }

    const deleteExchange = async (id)=>{
        await svc.delete(id)
        return onRefreshExchange()
    }


    const onRefreshExchange = ()=>{
        return svc.list().then((results)=> {
            setExchanges(results);
            let found;
            let l = {};
            results.forEach((r)=>{
                l[r.id] = exchangeLogos[r.type]
                if(r.id == selectedExchange){
                    found = true;
                    onSelectExchange(r.id).then()
                }
            })
            setLogos(l)
            if(!found){
                if(results.length){
                    onSelectExchange(results[0].id).then()
                } else {
                    setSelectedExchange(null)
                }

            }
        }).catch((e)=>{
            console.error(e)
        })
    }

    const toggleExchangeStatus = async (exchange) =>{
        if(exchange.enabled){
            await svc.disable(exchange.id)
        } else {
            await svc.enable(exchange.id)
        }

        await onRefreshExchange()
    }


    return <ExchangeContext.Provider value={{
        exchanges: exchanges,
        exchangesLoading: exchangesLoading,
        selectedExchangeID: selectedExchange,
        selectedImage: selectedImage,
        binanceLogo: exchangeLogos.binanceus,
        krakenLogo: exchangeLogos.kraken,
        coinbaseproLogo: exchangeLogos.coinbasepro,
        geminiLogo: exchangeLogos.gemini,
        logos: logos,
        userStatus: userStatus,
        onSelectExchange: onSelectExchange,
        refreshExchanges: onRefreshExchange,
        deleteExchange: deleteExchange,
        createExchange: createExchange,
        toggleExchangeStatus: toggleExchangeStatus,
    }}>
        {props.children}
    </ExchangeContext.Provider>
}


export {ExchangeContext, ExchangeProvider, setGlobalStatus}
